import React from 'react';
import Banner from '../Common/Banner';
import { Modal } from 'react-bootstrap';
import call from "../Core/Services";

import DocumentMeta from 'react-document-meta';

class CycleRent extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.state = {
			showModal: false,
			message : '',
			durationType: 'D',
		}		
	}

	submitForm = ( e ) => {
        
        e.preventDefault();

        let formData = {
            'name'      : this.refs.name.value,
            'email'     : this.refs.email.value,
            'phone'     : this.refs.phone.value,
            'comment'   : this.refs.comment.value,
            'category'  : 'RENTAL',

            'metaData'  : {
            	'duration'  	: this.refs.duration.value,
            	'durationType'	: this.state.durationType,
            	'people'  		: this.refs.peopleCount.value, 
            },
       };

        call.submitForm( formData, () => {
            
            this.refs.name.value    		 = '';
            this.refs.email.value       	 = '';
            this.refs.phone.value       	 = '';
            this.refs.comment.value     	 = '';
            this.refs.peopleCount.value     = '';
            this.refs.duration.value     = '';
    
            this.setState({
                message: 'Tak for din forespørgsel, vi svarer som regel i løbet af få timer'
            });

            setTimeout( () => {                
                this.setState({
                    message: ''
                });
            }, 10000)

        });
    }

    close = () => {
		this.setState({ showModal: false });
	}

	open = () => {
		this.setState({ showModal: true });
	}

	render() {
		
		const meta = {
			title: 			'Vi tilbyder den billigste og mest praktiske cykeludlejning i København',
			description: 	'I København er cyklen en del af vores hverdag. Hvis du gerne vil leve som en sand københavner, kan du ikke undvære en cykel. Alaska Cykler har den billigste løsning til dig.',
			canonical: 		window.location.href,
			meta: {
				charset: 	'utf-8',
				name: {
					keywords: 'cykeludlejning i københavn, billige cykler til leje, leje en cykel københavn'
				}
			}
	    };

		return (
			<div className="main-content" id="cycle-rent-page">
                
                <DocumentMeta {...meta} />

				<Banner 
					pageName='Cykeludlejning' 
					pageID='repair' 
					pageDesc='Oplev København på 2 hjul' 
					url='http://res.cloudinary.com/dttrnjoc5/image/upload/c_scale,f_auto,h_800,q_auto/v1511687696/backgrounds/bike_rentals_2400x1350_sz.jpg' />

				<div className="scroll-stop"></div>

				<div className="container">
					{/* Intro + 3-Step Booking Guide */}
					<div className="row rent-intro-section">
						<div className="col-md-7 col-sm-12">
							<div className="rent-story-card">
								<span className="section-overline">CYKELUDLEJNING I KØBENHAVN</span>
								<h3>Billige og overkommelige cykler til enhver lejlighed</h3>
								<p>I København er cyklen en uundværlig del af hverdagen. Hvis du gerne vil opleve byen som en ægte københavner, kan du ikke undvære en god cykel. Men hvad gør du, når din egen cykel er til reparation, eller du har brug for en ekstra cykel i nogle dage eller uger?</p>
								<p>Hos Alaska Cykler tilbyder vi en af Københavns billigste og mest fleksible løsninger. Vi har velholdte cykler til alle formål og budgetter – klar når du har brug for dem.</p>
								<p>Ved bestilling via telefon eller online formular gør vi cyklen klar på forhånd. Oplys gerne, om du har brug for ekstraudstyr som hjelm, lygter eller cykeltasker samt ønsket afhentnings- og afleveringstidspunkt.</p>

								<div className="rent-highlights">
									<div className="highlight-item">
										<span className="pe-7s-bicycle" /> Kvalitetscykler klar til brug
									</div>
									<div className="highlight-item">
										<span className="pe-7s-shield" /> Mulighed for hjelm &amp; udstyr
									</div>
									<div className="highlight-item">
										<span className="pe-7s-clock" /> Fleksibel leje fra 6 timer
									</div>
								</div>

								<button type="button" className="btn btn-primary" onClick={this.open}>
									Send Os Din Forespørgsel
								</button>
							</div>
						</div>

						<div className="col-md-5 col-sm-12">
							<div className="rent-steps-card">
								<h3>Sådan lejer du en cykel</h3>
								<p className="steps-sub">Vi tilbyder forskellige muligheder – nemt og hurtigt i 3 trin</p>

								<ul className="modern-steps">
									<li>
										<span className="step-badge">1</span>
										<div className="step-body">
											<h4>Bestil online eller pr. telefon</h4>
											<p>Send os din forespørgsel med antal cykler og lejeperiode, eller ring direkte til butikken.</p>
											<span className="step-link" onClick={this.open}>Send forespørgsel &rarr;</span>
										</div>
									</li>
									<li>
										<span className="step-badge">2</span>
										<div className="step-body">
											<h4>Personlig betjening &amp; klargøring</h4>
											<p>Vi klargør og sikkerhedstjekker dine lånecykler, så alt står skarpt, når du ankommer.</p>
										</div>
									</li>
									<li>
										<span className="step-badge">3</span>
										<div className="step-body">
											<h4>Afhent i vores fysiske butik</h4>
											<p>Kom forbi Islevhusvej 7 ved Husum Torv, få indstillet sadlen og få personlig rådgivning.</p>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>

					{/* Pricing Table Section */}
					<header className="header header-main row">
						<h2 className="col-md-12">
							Udlejningspriser
							<p>Gennemskuelige priser for cykel og cykelhjelm – jo længere du lejer, desto mere sparer du</p>
						</h2>
					</header>

					<div className="rent-table-card">
						<div className="table-responsive">
							<table className="table">
								<thead>
									<tr>
										<th width="40%">Udlejningsperiode</th>
										<th width="30%">Standard Cykel</th>
										<th width="30%">Cykelhjelm</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>6 timer</td>
										<td className="price-cell">70 kr.</td>
										<td>30 kr.</td>
									</tr>
									<tr>
										<td>24 timer <span className="rate-badge">Populær</span></td>
										<td className="price-cell">100 kr.</td>
										<td>30 kr.</td>
									</tr>
									<tr>
										<td><span className="sub-rate">Ekstra dag (efter 24 timer)</span></td>
										<td className="price-cell">40 kr.</td>
										<td>10 kr.</td>
									</tr>
									<tr>
										<td>1 uge <span className="rate-badge">Bedste værdi</span></td>
										<td className="price-cell">375 kr.</td>
										<td>90 kr.</td>
									</tr>
									<tr>
										<td><span className="sub-rate">Ekstra dag (efter 1 uge)</span></td>
										<td className="price-cell">25 kr.</td>
										<td>5 kr.</td>
									</tr>
									<tr>
										<td>2 uger</td>
										<td className="price-cell">540 kr.</td>
										<td>115 kr.</td>
									</tr>
									<tr>
										<td>3 uger</td>
										<td className="price-cell">680 kr.</td>
										<td>130 kr.</td>
									</tr>
									<tr>
										<td>4 uger</td>
										<td className="price-cell">800 kr.</td>
										<td>145 kr.</td>
									</tr>
									<tr>
										<td>2 måneder</td>
										<td className="price-cell">1190 kr.</td>
										<td>240 kr.</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div className="rent-table-footer">
							<p className="footer-note">
								<strong>Har du spørgsmål eller brug for flere cykler?</strong> Send en uforpligtende forespørgsel, så svarer vi hurtigst muligt.
							</p>
							<button type="button" className="btn btn-primary" onClick={this.open}>
								Send Os Din Forespørgsel
							</button>
						</div>
					</div>

                    <Modal show={this.state.showModal} onHide={this.close}>
						<Modal.Header closeButton>
							<Modal.Title>Forhør nu for flere detaljer</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<div className="row">
								<div className="col-md-12">
									
									<div className={ this.state.message ? 'alert alert-success show' : 'alert alert-success' }>
		                                <a className="close" onClick={ () => this.setState({message: '' }) } >&times;</a>
		                                { this.state.message }
		                            </div>

									<form id="rent-enquire-form" method="post" onSubmit={ this.submitForm } >
										
										<div className="row">
											<div className="form-group col-md-6">
												<label className="sr-only" htmlFor="first-name">Navn</label>
												<input type="text" required ref="name" name="first-name" placeholder="Navn" minLength={3} maxLength={15} className="form-control" />
											</div>
											<div className="form-group col-md-6">												
												<label className="sr-only" htmlFor="phone-number">Telefonnummer</label>
												<input type="number" required ref="phone" name="phone-number" placeholder="Telefonnummer" className="form-control" />
											</div>
										</div>

										<div className="row">
											<div className="form-group col-md-12">
												<label className="sr-only" htmlFor="email">Email Adresse</label>
												<input type="email" required ref="email" name="email" placeholder="Email adresse" minLength={3} maxLength={50} className="form-control" />
											</div>
										</div>

										<div className="row">
											<div className="form-group col-md-6">
												<label className="sr-only" htmlFor="people-count">Antal Cykler</label>
												<input type="number" required ref="peopleCount" name="people-count" placeholder="Antal Cykler" minLength={1} maxLength={25} className="form-control" />
											</div>
											<div className="form-group col-md-6">												
												<label className="sr-only" htmlFor="duration">Udlejningsperiode </label>
												<input type="number" required ref="duration" name="duration" placeholder="Udlejningsperiode" className="form-control" />
												
												<div style={{position: 'absolute', right: '25px', top:'9px'}} >
													<div className="switch-field">
														<input type="radio" value="H" required name="duration-type" id="duration-type-h" />
														<label onClick={ () => this.setState({durationType: 'H'})} htmlFor="duration-type-h">Timer</label>
													
														<input type="radio" value="D" required name="duration-type" id="duration-type-d" defaultChecked />
														<label onClick={ () => this.setState({durationType: 'D'})} htmlFor="duration-type-d">Dage</label>
													</div>
												</div>
											</div>
										</div>

										<div className="row">
											<div className="form-group col-sm-12">
												<label className="sr-only">Forespørgselsdetaljer</label>
												<textarea required ref="comment" name="enquiry_details" className="form-control" minLength={10} maxLength={300} rows={5} placeholder="Indtast din forespørgsel her..." />
											</div>
										</div>

										<div className="row">
											<div className="form-group col-xs-12 col-sm-5">
												<input type="submit" name="Submit" className="btn btn-primary btn-block" defaultValue="Indsend" />
											</div>
										</div>
																		
									</form>

								</div>
							</div>
						</Modal.Body>
					</Modal>

                </div>
				
			</div>
		);
	}
}

export default CycleRent;




// WEBPACK FOOTER //
// ./src/Pages/CycleRent.js